import CargoLinesList from '../../../../components/Purchasing/Cargo/Lines/CargoLinesList'
import CargoLinesModal from '../../../../components/Purchasing/Cargo/Lines/CargoLinesModal'

import React, { Fragment } from 'react'

function CargoLines(props) {
  return (
    <Fragment>
      <CargoLinesModal {...props} />
      <CargoLinesList {...props} />
    </Fragment>
  )
}

export default CargoLines
